import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=9d977f2e&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d977f2e"]])

export default __exports__